export const buildPayload = (formData: any, gridData: any, rawMaterialData: any, dropdowns: any) => {
    return {
        productHeaderItemMaster: {
            productName: formData?.productName?.trim() || "",
            styleNoId: toNullableNumber(formData?.styleNumber),
            materialTypeId: toNullableNumber(formData?.materialType),
            categoryId: toNullableNumber(formData?.category),
            subCategoryId: toNullableNumber(formData?.subCategory),
            isFix: Boolean(formData?.productType === 1),
            metalColorId: toNullableNumber(formData?.metalColor),
            collectionId: toNullableNumber(formData?.collection),
            complexityId: toNullableNumber(formData?.complexity),
        },
        productDetailsModels: {
            productDetailsItemMaster: {
                size: toNullableWtRate(gridData?.size),
                weight: toNullableWtRate(gridData?.weight),
                materialTypeId: toNullableNumber(gridData?.materialType),
                karatId: toNullableNumber(gridData?.karat),
                metalColorId: toNullableNumber(gridData?.metalColor),
                diamondQty: toNullableWtRate(gridData?.diamondQty),
                netWeight: toNullableWtRate(gridData?.netWeight),
                stoneType: gridData?.stoneType?.trim() || "",
                makingType: gridData?.makingType?.trim() || "",
                tag: gridData?.tag?.trim() || "",
                collorStoneWeight: toNullableWtRate(gridData?.collorStoneWeight)
            },
            itemMasterRawMaterials: (rawMaterialData ?? []).map((rm: any) => ({
                mf: rm?.mf?.trim() || "",
                rowType: getTextFromList(rm?.rowType, dropdowns.rowMaterialTypeList),
                weight: toNullableWtRate(rm?.weight),
                karatId: toNullableNumber(rm?.rawkarat),
                qty: toNullableWtRate(rm?.qty),
                stoneWeight: toNullableWtRate(rm?.stoneWeight),
                diamondWt: toNullableWtRate(rm?.diamondWt),
                diamondSize: toNullableWtRate(rm?.diamondSize)
            }))
        }
    };
};

export const getTextFromList = (value: string, list: any[]): string => {
    const item = list.find(item => item.value === value);
    return item ? item.label : '';
};

const toNullableNumber = (value: unknown): number | null => {
    if (value === null || value === undefined || value === "") {
        return null;
    }

    const num = Number(value);
    return isNaN(num) ? null : num;
};

const toNullableWtRate = (value: unknown): number => {
    if (value === null || value === undefined || value === "") {
        return 0;
    }

    const num = Number(value);
    return isNaN(num) ? 0 : num;
}